import axios from "axios";

export const apiService = {
  getGroupAttendanceAll: async (date, location) => {
    try {
      const response = await axios.get(
        `attme/GetGroupAttendanceAll?date=${date}&location=${location}`,
        {
          headers: {
            UserId: "DTSUSER",
            Password: "Dts@10099",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLocationsByCompany: async (company) => {
    try {
      const response = await axios.get(
        `attme/GetLocationsByCompany?company=${company}`,
        {
          headers: {
            UserId: "DTSUSER",
            Password: "Dts@10099",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};